// Copyright (c) 2020 Deere & Company

import actions from '../actions-list';

const defaultValue = {};

const setReports = ( state, action ) => ( {
    ...state,
    [action.unit]: action.reports
} );

export default ( state = defaultValue, action ) => {

    const actionTypes = {
        [actions.SET_REPORTS]: setReports
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer( state, action ) :
        state;

};
